export const ClassTypes = [
  { value: "AT", text: 'حضوری' },
  { value: "ON", text: 'مجازی' },
  { value: "MI", text: 'دو نفره' },


]
const ClassTypeSetter = (val) => {

  let value = null
  ClassTypes.forEach((el) => {
    if (el.value === val) {
      value = el.text;
    }
  })
  return value;
}
export default ClassTypeSetter;
